<template>
  <TabGroup :defaultIndex="0" v-if="menu.length > 0">
    <TabList class="flex justify-between p-4">
      <Tab v-slot="{ selected }"
           v-for="category in menu"
           :key="category.id">
        <router-link :to="isChooseFood() ? `/submit-order/menu/${category.id}` : `/menu/${category.id}`"
                     class="text-white py-1 px-2 text-sm rounded-lg"
                     :class="[selected ? 'bg-yellow-500' : '']">
          {{ category.menu_Name }}
        </router-link>
      </Tab>
    </TabList>
    <TabPanels>
      <TabPanel v-for="category in menu"
                :key="category.id" class="bg-gray-700">

        <div class="flex overflow-scroll">
          <SubMenuCard v-for="subMenu in category.subMenus"
                       :key="subMenu.id" :subMenu="subMenu"/>
        </div>

<!--        <LoadingProgressBar/>-->
<!---->
        <router-view></router-view>

      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>

<script>
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/vue'
import {getMenu} from "@/API/API";
import SubMenuCard from "@/components/SubMenuCard";

export default {
  name: 'Menu',
  components: {
    SubMenuCard,
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
  },
  data() {
    return {
      menu: [],
    }
  },
  async created() {
    this.menu = (await getMenu()).data.result

    if (this.isChooseFood()) {
      // Load the First Menu as Default
      this.$router.push(`/submit-order/menu/${this.menu[0].id}`)
    } else {
      this.$router.push(`/menu/${this.menu[0].id}`)
    }
  },
  methods: {
    isChooseFood() {
      return this.$route.matched.some(record => record.name === 'ChooseFood');
    },
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'Menu') {
        // Load the First Menu as Default
        this.$router.push(`/menu/${this.menu[0].id}`)
      }
    }
  }
}
</script>

<style>

</style>
